/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as l from "react";
import { useUnstyled as u, classNames as c, uCalendar as s } from "@progress/kendo-react-common";
const N = (e) => {
  const { isRangeStart: i, value: o, text: C, view: v, ...r } = e, a = u(), t = a && a.uCalendar, m = (d) => {
    const { onClick: n } = e;
    n && n.call(void 0, o, d);
  };
  return /* @__PURE__ */ l.createElement(
    "li",
    {
      ...r,
      onClick: m,
      className: c(s.li({ c: t }))
    },
    /* @__PURE__ */ l.createElement("span", { className: c(
      s.navigationMarker({
        c: t,
        isRangeStart: i
      })
    ) }, e.children)
  );
};
export {
  N as CalendarNavigationItem
};
